import { CommonState, CommonStateActionTypes } from './types'
import { ACTION_TYPES } from './context'

export default function commonReducer(
  state: CommonState,
  action: CommonStateActionTypes,
): CommonState {
  switch (action.type) {
    case ACTION_TYPES.UPDATE_MOBILE_PLATFORM_TYPE:
      return {
        ...state,
        ...action.payload,
      }

    case ACTION_TYPES.SET_PAYMENT_CHILDWINDOW:
      return {
        ...state,
        ...action.payload,
      }
    case ACTION_TYPES.UPDATE_FINVU_CLIENT_SCRIPT_STATUS:
      return {
        ...state,
        ...action.payload,
      }
    case ACTION_TYPES.UPDATE_FINVU_PHONE_NUMBER:
      return {
        ...state,
        ...action.payload,
      }
    case ACTION_TYPES.UPDATE_FINVU_HANDLE_ID:
      return {
        ...state,
        ...action.payload,
      }
    case ACTION_TYPES.UPDATE_STAGING_ENV:
      return {
        ...state,
        stagingEnv: action.payload.stagingEnv,
      }

    case ACTION_TYPES.UPDATE_OVERLAY_ZINDEX: {
      const toIncrease = action.payload.type === 'increase'
      const toDecrease = action.payload.type === 'decrease'
      let overlayZIndex = { ...state }.overlayZIndex

      if (toIncrease) {
        overlayZIndex++
      }

      if (toDecrease) {
        overlayZIndex--
      }

      return {
        ...state,
        overlayZIndex,
      }
    }

    default:
      return state
  }
}
